import React, { useState } from "react";
import { Collapse, Radio, Typography, Row, Col } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import AnimationChildWrapper from "../../../../components/animations/AnimationChildWrapper";
import { InputItem } from "../../../../components/forms/FormItems";
import { UsersSelect } from "../../../../components/forms/AutoCompleteFormItem";
import { useSelector } from "react-redux";
const { Text } = Typography;
const { Panel } = Collapse;

const ContactForm = (props) => {
  const { record } = props;
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  const intl = useIntl();
  const [value, setValue] = useState(1);
  const [collapseActiveKey, setCollapseActiveKey] = useState(["0"]);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const onCollapseChange = (keys) => {
    setCollapseActiveKey(keys);
  };

  const items =
    value === 1
      ? [
          {
            name: "surename",
            required: true,
            comp: (
              <InputItem required={true} name="surename" category="contact" />
            ),
          },
          {
            name: "first_name",
            required: true,
            comp: (
              <InputItem required={true} name="first_name" category="contact" />
            ),
          },

          {
            name: "contact_owner_id",
            required: true,
            comp: (
              <UsersSelect
                name="contact_owner_id"
                category="contact"
                required={true}
                // getUser={branch_id !== null}
                extraParams={{
                  scopePrefix: scopePrefix,
                  filter: {},
                }}
              />
            ),
          },
        ]
      : [
          {
            name: "contact_owner_id",
            required: true,

            comp: (
              <UsersSelect
                name="contact_owner_id"
                category="contact"
                required={true}
                // getUser={branch_id !== null}
                extraParams={{
                  scopePrefix: scopePrefix,
                  filter: {},
                }}
              />
            ),
          },
        ];

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={["0"]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      collapsible="icon"
      className="custom-collapse-section"
      activeKey={collapseActiveKey}
      onChange={onCollapseChange}
    >
      <Panel
        key="0"
        header={
          <div style={{ display: "flex" }}>
            <Text>
              {intl.formatMessage({
                id: "app.leads.convert_contact_title",
              })}
            </Text>
            <div style={{ width: "40px" }} />

            <Radio.Group onChange={onChange} value={value}>
              <Radio value={1}>
                {intl.formatMessage({
                  id: "app.leads.create_new_contact",
                })}
              </Radio>
              <Radio value={2}>
                {intl.formatMessage({
                  id: "app.leads.choose_existing_contact",
                })}
              </Radio>
            </Radio.Group>
          </div>
        }
      >
        <div>
          <Row>
            {items.map((item, i) => (
              <Col key={i} span={12} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={i} itemKey={i}>
                  {item.comp}
                </AnimationChildWrapper>
              </Col>
            ))}
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
};
export default ContactForm;
